module.exports = __webpack_public_path__ + "static/media/0849_2017Gallery.67b93d19.JPG";